import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form__radiogroup mb-24" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("legend", { class: "invisible" }, " Project Status ", -1 /* HOISTED */)
const _hoisted_3 = ["for"]
const _hoisted_4 = ["id", "value"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["SimpleModalComponent"], {
    heading: "Project Status",
    onCloseModal: _cache[2] || (_cache[2] = $event => ($setup.emit( 'close-modal' )))
  }, {
    content: _withCtx(() => [
      _createElementVNode("fieldset", _hoisted_1, [
        _hoisted_2,
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.statuses, (status) => {
          return _createElementVNode("label", {
            key: 'status-' + status.value,
            for: status.value,
            class: "form__radio"
          }, [
            _withDirectives(_createElementVNode("input", {
              id: status.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.project_status) = $event)),
              type: "radio",
              name: "project-status",
              value: status.value
            }, null, 8 /* PROPS */, _hoisted_4), [
              [_vModelRadio, $setup.project_status]
            ]),
            _createTextVNode(" " + _toDisplayString(status.label), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_3)
        }), 64 /* STABLE_FRAGMENT */))
      ])
    ]),
    buttons: _withCtx(() => [
      _createElementVNode("button", {
        class: "button",
        disabled: $setup.loading,
        onClick: _cache[1] || (_cache[1] = $event => ($setup.emit( 'close-modal' )))
      }, " Cancel ", 8 /* PROPS */, _hoisted_5),
      _createElementVNode("button", {
        class: _normalizeClass(["button button--fill", { 'button--loading' : $setup.loading }]),
        disabled: $setup.loading,
        onClick: $setup.updateProjectStatus
      }, " Save ", 10 /* CLASS, PROPS */, _hoisted_6)
    ]),
    _: 1 /* STABLE */
  }))
}